import getIsEmbedded from '../util/embedded';

export const useIsEmbedded = () => {
  const isEmbedded = getIsEmbedded();
  return isEmbedded;
};
